<template>
  <div>
    <v-card class="main-card" outlined>
      <v-card-title class="pb-0 light-primary">
        <v-row justify="start">
          <v-col md="6" cols="12">
            <ScanInput
              :autoFocus="autoFocus"
              :autoComplete="off"
              :caseId="caseId"
              :id="inputId"
              :label="'QR-code / AZV barcode / Tube barcode'"
              :scannedInput="scannedInput"
              :primarySubject="primarySubject"
              v-on:disableScanInput="disableScanInput"
              v-on:displaySubjectData="displaySubjectDataInParent"
              v-on:displayTestTubeData="displayTestTubeData"
              v-on:setTestTubeKitInfoToNull="setTestTubeKitInfoToNull"
              v-on:hideLoadProgress="hideLoadProgress"
              v-on:resetAllData="resetAllData"
              v-on:setTestTubeMessage="setTestTubeMsg"
              v-on:focusScanInput="focusScanInput"
              v-on:printLinkedSubjectInfo="printLinkedSubjectInfo"
              v-on:showScannerModal="displayScannerModal"
              v-on:scan="scan"
            />
          </v-col>

          <v-col md="6" cols="12" class="mt-0 d-flex" :class="this.$vuetify.breakpoint.smAndDown ? 'justify-end' : ''">
            <div v-if="dataDisplayed">
              <v-btn large @click="$parent.showPaymentMethodModal = true" color="success" class="me-4 px-8" :disabled="$parent.saveButtonDisabled">
                <v-icon left>mdi-content-save</v-icon> Save
              </v-btn>

              <ScanInputCardCancelModal @cancelScan="cancelScan" :disableScanInput="disableScanInput" />

              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" fab>
                    <v-icon large>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item disabled>
                    <v-list-item-content>
                      <v-list-item-title><v-icon left>mdi-cash</v-icon>Save &amp; Pay</v-list-item-title>
                      <v-list-item-subtitle class="error--text">Please use the default save button for save and pay</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="printLastSubjectData()">
                    <v-list-item-title><v-icon left>mdi-printer</v-icon>Print Last</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div v-else>
              <v-btn @click="printLastSubjectData(false)" color="primary" class="mt-3 mr-2"> <v-icon left>mdi-printer</v-icon> Print Last </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
    <ScannerModal :showModal="showScannerModal" v-if="showScannerModal" @qrScanned="qrScanned" :readyForTubeScan="readyForTubeScan" />
  </div>
</template>

<script>
import ScanInputCardCancelModal from '@/views/TestTubeLinkPage/components/ScanInputCard/components/ScanInputCardCancelModal.vue';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import ScanInput from '@/components/ScanInputComponent/ScanInput.vue';
import ScannerModal from '@/views/TestTubeLinkPage/components/ScanInputCard/components/ScannerModal.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [SharedFunctions],
  props: ['disableScanInput', 'dataDisplayed', 'caseId', 'autoFocus', 'inputId', 'primarySubject'],
  components: {
    ScanInputCardCancelModal,
    ScannerModal,
    ScanInput
  },
  data() {
    return {
      //prod tests: ^^00a7cfb1-4cba-498e-8adc-509a62b7d66d^, ^^697d1bfc-1e73-4581-831d-311dc2470a7e^
      //tube code: C1990000001
      scannedInput: null,
      scanInputLoading: false,
      readyToScan: false,
      testTypePrefixLength: null,
      showScannerModal: false
    };
  },
  created() {
    console.log(this.autoFocus);
  },
  computed: {
    canSaveAndPay() {
      if (this.$store.getters.userObject.roles.includes('hoh_pay')) {
        return true;
      }
      return false;
    },
    readyForTubeScan() {
      return this.dataDisplayed;
    },
    testTypes_() {
      return this.testTypes;
    },
    ...mapGetters('testTypeStore', ['testTypes'])
  },
  methods: {
    displaySubData() {
      this.$emit('displaySubjectData');
    },
    displayTestTubeData(testTubeData, codeTypeInput) {
      this.$emit('displayTestTubeData', testTubeData, codeTypeInput);
    },
    focusScanInput() {
      this.$emit('focusScanInput');
    },
    cancelScan() {
      this.$emit('hideLoadProgress');
      this.$emit('resetAllData');
      setTimeout(() => document.getElementById('scanTextInput').focus(), 100);
    },
    scan(input) {
      this.$store.commit('SET_SHOW_LOADER', { action: true, text: 'Loading case....' });
      this.setTestTubeKitInfoToNull();
      this.scannedInput = null;
      this.$store
        .dispatch('testTubeLinkStore/scan', { input: input, primarySubject: this.primarySubject })
        .then((scanResult) => {
          if (scanResult.displaySubjectData) {
            this.displaySubjectDataInParent(scanResult.displaySubjectData, scanResult.id); //(subjectData, codeType.caseId || subjectDataAzv[0].id)
          } else if (scanResult.error) {
            this.displayScanError(scanResult.error);
          } else if (scanResult.displayTestTubeData) {
            this.$emit('displayTestTubeData', scanResult.displayTestTubeData, scanResult.input);
          } else if (scanResult.testTubeMessage) {
            this.$emit('setTestTubeMessage', scanResult.testTubeMessage);
          }

          this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
        });
    },
    setTestTubeMsg() {
      this.$emit('setTestTubeMessage', null);
    },
    setTestTubeKitInfoToNull() {
      this.$emit('setTestTubeKitInfoToNull');
    },
    printLastSubjectData() {
      const lastPrintedSubject = JSON.parse(localStorage.getItem('hohApp_lastLinkedSubject'));
      if (lastPrintedSubject && lastPrintedSubject.data) {
        this.$emit('printLinkedSubjectInfo', lastPrintedSubject.data, lastPrintedSubject.lastScannedBarcode);
      } else {
        let payload = {
          open: true,
          text: 'No saved subjects found to print',
          color: 'warning'
        };
        this.$store.commit('SET_SNACKBAR', payload);
      }
    },
    displaySubjectDataInParent(subjectData, caseId) {
      if (subjectData) {
        this.$emit('displaySubjectData', subjectData, caseId);
      } else {
        this.scanInputLoading = false;
        this.$emit('focusScanInput');
      }
    },
    displayScanError(mesg) {
      let payload = {
        open: true,
        text: mesg,
        color: 'error'
      };
      this.$store.commit('SET_SNACKBAR', payload);

      this.scanInputLoading = false;
      this.scannedInput = null;
      this.$emit('focusScanInput');
    },
    qrScanned(scannedInput) {
      this.showScannerModal = false;
      this.scannedInput = scannedInput;
      this.$emit('setScannedWithMobileDevice', true);
      this.scan(scannedInput);
    },
    displayScannerModal() {
      this.showScannerModal = true;
    }
  }
};
</script>

<style lang="scss">
.main-card {
  .small-text {
    font-size: 12px;
    top: -9px;
    padding: 0;
    position: relative;
    font-weight: 500;
    color: grey;
  }
}
</style>
